export const MAX_PRODUCT_CARD_BUNDLE_ICON_SIZE = 4;
export const DESKTOP_MIN_WIDTH = 961;
